import type { DateTime, UTCDate } from "../date";
import type { DocumentSelectionCriterion } from "./document-selection.model";

export enum DocumentLockMode {
  Unlocked = "Unlocked",
  LockedByCandidateOwner = "LockedByCandidateOwner",
  LockedByAProcessOwner = "LockedByAProcessOwner",
  LockedByExternalSubmission = "LockedByExternalSubmission",
}

export enum DocumentMode {
  Organization = "Organization",
  Template = "Template",
  Candidate = "Candidate",
}

export enum CompletionState {
  Complete = "Complete",
  Incomplete = "Incomplete",
}

export enum FileAccess {
  Full = "Full",
  None = "None",
}

export enum DocumentAccess {
  ReadWriteDocument = "ReadWriteDocument",
  ReadWriteDocumentWhenNotInternal = "ReadWriteDocumentWhenNotInternal",
  ReadDocumentAndReadWriteMetadata = "ReadDocumentAndReadWriteMetadata",
  ReadDocumentWhenNotInternalAndReadWriteMetadata = "ReadDocumentWhenNotInternalAndReadWriteMetadata",
  ReadWriteMetadata = "ReadWriteMetadata",
  ReadDocument = "ReadDocument",
  ReadDocumentWhenNotInternal = "ReadDocumentWhenNotInternal",
  None = "None",
}

export enum DocumentWriteMode {
  Full = "Full",
  Metadata = "Metadata",
  None = "None",
}

export interface DocumentSigningConfigModel {
  enabled: boolean;
  roles?: { roleName: string }[];
}

export interface DocumentModel {
  organizationId: string;
  type?: string;
  candidateId?: string;
  familyMemberId?: string;
  mode: DocumentMode;
  comment?: string;
  documentSets?: DocumentSetModel[];
  freeFormatFiles?: DocumentFreeFormatFileModel[];
  selectionCriteria?: DocumentSelectionCriterion[];
  completionState?: CompletionState;
  isInternalDocument?: boolean;
  isInternalByRequirement?: boolean;
  availableForCandidates?: boolean;
  signingConfig?: DocumentSigningConfigModel;
}

export interface DocumentSetModel {
  id: string;
  isDefaultSet: boolean;
  name?: string;
  type?: string;
  foreignKey?: string;
  validFrom?: UTCDate;
  validUntil?: UTCDate;
  issueDate?: UTCDate;
  dateOfReceipt?: UTCDate;
  resubmissionDate?: UTCDate;
  resubmissionReason?: string;
  physicalTypes?: string[];
  files?: DocumentFileModel[];
}

export interface DocumentFreeFormatFileModel {
  blob: string;
  name: string;
  size: number;
  type: string;
  createdAt?: DateTime;
}

export interface DocumentFileModel extends DocumentFreeFormatFileModel {
  tags?: string[];
  selectionValues?: string[][];
  singleSetConfig?: SingleSetConfigModel[];
}

export interface SingleSetConfigModel {
  type: string;
  formats: string[];
}

export function isDocumentSelectionMode(mode: DocumentMode): boolean {
  return mode === DocumentMode.Template || mode === DocumentMode.Organization;
}
